module.exports = __webpack_public_path__ + "media/images/emblems/Novazzano-blason-770c8897d1cdfb21d2d3cf96a5b06804.svg";